// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3KNOF","infoBtn":"quickbooks_infoBtn__2ltaV","formBox":"quickbooks_formBox__3AlBK","formFooter":"quickbooks_formFooter__rp3XZ"};